import type { ReactNode } from 'react';
import type { DropdownMenuRadioGroupProps } from '@radix-ui/react-dropdown-menu';
import { DropdownMenuRadioGroup } from '@radix-ui/react-dropdown-menu';

export type MenuRadioGroupProps = DropdownMenuRadioGroupProps & {
  /**
   * The radio items
   */
  children: ReactNode | ReactNode[];

  /**
   * @ignore
   */
  asChild?: never;
};

export const MenuRadioGroup = ({ children, ...props }: MenuRadioGroupProps) => {
  return <DropdownMenuRadioGroup {...props}>{children}</DropdownMenuRadioGroup>;
};

MenuRadioGroup.displayName = 'MenuRadioGroup';
